import React from "react";
import { Link } from "react-router-dom";

interface Props {
  ticker: string;
}

const CompFinderItem = ({ ticker }: Props) => {
  return (
    <Link
      reloadDocument
      to={`/company/${ticker}/company-profile`}
      type="button"
      className="inline-flex items-center p-4 rounded-l-lg transition 
           hover:bg-gray-200 hover:shadow-md hover:cursor-pointer"
    >
      {ticker}
    </Link>
  );
};

export default CompFinderItem;
